import {
  Box
} from '@mui/material';
import ActionButtonsFormik from 'components/forms/ActionButtonsFormik';
import ComponentTipoDecreto from 'components/forms/ComponentTipoDecreto';
import { ContainerFormFormik } from 'components/shared/container_form_formik';
import InputBooleanFormik from 'components/shared/custom_input_boolean_formik';
import InputComLabelFormik from 'components/shared/custom_input_label_formik';
import { useFormik } from 'formik';
import { useFormularioSecretariaMunicipalAgriculturaStore } from '../../../../../../stores/forms/formularioAgricultura.store';
import { step2ValidationSchema } from './step2.validation';
const Step2: React.FC = () => {
  const { formulario, setPartialForm, salvarRascunho } =
    useFormularioSecretariaMunicipalAgriculturaStore();


  const handleSave = (values: any) => {
    setPartialForm('fundo_municipal_agricultura_familiar', values.fundo_municipal_agricultura_familiar);
    setPartialForm('tipo_publicacao', values.tipo_publicacao);
    setPartialForm('nro_publicacao', values.nro_publicacao);
    setPartialForm('data_publicacao', values.data_publicacao);
    setPartialForm('orcamento_secretaria', values.orcamento_secretaria);
    setPartialForm('porcentagem_orcamento_ano_corrente', values.porcentagem_orcamento_ano_corrente.replace('%', ''));
    setPartialForm('step_atual', 3);
    salvarRascunho();
  }

  const formik = useFormik({
    initialValues: {
      fundo_municipal_agricultura_familiar: formulario?.fundo_municipal_agricultura_familiar,
      tipo_publicacao: formulario?.tipo_publicacao || '',
      nro_publicacao: formulario?.nro_publicacao,
      data_publicacao: formulario?.data_publicacao,
      orcamento_secretaria: formulario?.orcamento_secretaria,
      porcentagem_orcamento_ano_corrente: formulario?.porcentagem_orcamento_ano_corrente,
    },
    validationSchema: step2ValidationSchema,
    validateOnChange: true,
    validateOnBlur: false,
    onSubmit: (values: any) => {
      handleSave(values);
    },
  })

  return (
    <>
      <ContainerFormFormik title='Informações Complementares' onSubmit={formik.handleSubmit}>

        <Box
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          gap={4}
          display={'flex'}
          flexDirection={'column'}
        >
          <InputBooleanFormik
            formik={formik}
            label='fundo_municipal_agricultura_familiar'
            labelTexto='O Município possui Fundo Municipal destinado ações para a Agricultura Familiar?'
          />

          {formik.values.fundo_municipal_agricultura_familiar && (
            <>
              <ComponentTipoDecreto
                formik={formik}
                label='tipo_publicacao'
                labelText='1. Informe o tipo da publicação:'
              />
              <InputComLabelFormik
                formik={formik}
                label='nro_publicacao'
                labelTexto='2. Número da publicação do instrumento legal que criou o Fundo:'
                placeholder='101'
                required
              />

              <InputComLabelFormik
                formik={formik}
                label='data_publicacao'
                labelTexto='3. Data da publicação do instrumento legal que criou o Fundo:'
                placeholder='10/01/2024'
                type='date'
                required
              />

              <InputComLabelFormik
                formik={formik}
                label='orcamento_secretaria'
                labelTexto='4. Qual valor do orçamento anual (R$) do municipio foi destinado para a Secretária/Órgão Municipal de Agricultura no último ano?'
                placeholder='0,00'
                required
                mask='dinheiro'
              />

              <InputComLabelFormik
                formik={formik}
                label='porcentagem_orcamento_ano_corrente'
                labelTexto='5. O valor informado acima, equivale a qual porcentagem do orçamento anual total do municipio?'
                placeholder='10%'
                maxLength={4}
                required
                mask='porcentagem'
              />
            </>
          )}
        </Box>
        <ActionButtonsFormik
          disabled={formik.isSubmitting}
        />
      </ContainerFormFormik>
    </>
  );
};

export default Step2;
